import { useAuth } from '@/hooks/use-auth';
import { Button } from '@/shared/ui/button';
import { Link, createFileRoute } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/')({
  component: LandingPage,
});

function LandingPage() {
  const { user } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30">
      <div className="w-full max-w-md space-y-8 px-4 text-center">
        <div className="flex flex-col items-center gap-4">
          <div className="inline-flex items-center gap-2 rounded-lg bg-[#65211a] px-4 py-2 text-sm font-semibold uppercase tracking-wide text-white">
            <Building2 className="size-4" />
            Invisible
          </div>
          <h1 className="text-4xl font-bold">
            Finance{' '}
            <span className="bg-gradient-to-r from-[#65211a] to-[#8b2e23] bg-clip-text text-transparent">
              Platform
            </span>
          </h1>
        </div>
        <p className="text-muted-foreground">
          {user ? `Welcome back, ${user.email}` : 'Please log in to access your dashboard'}
        </p>
        <div className="flex justify-center gap-4">
          {!user && (
            <Button asChild className="bg-[#65211a] hover:bg-[#4a1813]">
              <Link to="/login">Login</Link>
            </Button>
          )}
          {user && (
            <Button asChild className="bg-[#65211a] hover:bg-[#4a1813]">
              <Link to="/dashboard">Go to Dashboard</Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
